import { createAction, handleActions, combineActions } from 'redux-actions';
// api
import api from '../../utils/api';

const initialState = {
  resource: null,
  isLoading: false
};

// const
export const GET_MODULE = 'module/GET_MODULE';
export const GET_LECTURE_CONDITION = 'module/GET_LECTURE_CONDITION';
export const FETCH_STEP = 'module/FETCH_STEP';
export const SET_FAVORITE_VIDEO = 'module/SET_FAVORITE_VIDEO';
export const DELETE_FAVORITE_VIDEO = 'module/DELETE_FAVORITE_VIDEO';

// action creators
export const getModule = createAction(GET_MODULE, api.module.getModule);
export const getLectureCondition = createAction(
  GET_LECTURE_CONDITION,
  api.module.getLectureConditions
);
export const fetchStep = createAction(FETCH_STEP, api.module.fetchStep);
export const setFavoriteVideo = createAction(
  SET_FAVORITE_VIDEO,
  api.video.setFavoriteVideo
);
export const deleteFavoriteVideo = createAction(
  DELETE_FAVORITE_VIDEO,
  api.video.deleteFavoriteVideo
);

// reducer
const reducer = handleActions(
  {
    [`${GET_MODULE}_REQUEST`]: state => {
      return {
        ...state,
        resource: null,
        isLoading: true
      };
    },
    [`${GET_MODULE}_SUCCESS`]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
        isLoading: false
      };
    },

    [`${GET_LECTURE_CONDITION}_REQUEST`]: state => {
      return {
        ...state,
        isLoading: true
      };
    },

    [`${GET_LECTURE_CONDITION}_SUCCESS`]: state => {
      return {
        ...state,
        isLoading: false
      };
    },

    [`${FETCH_STEP}_REQUEST`]: state => {
      return {
        ...state,
        isLoading: true
      };
    },

    [`${FETCH_STEP}_SUCCESS`]: (state, { payload }) => {
      const fetchedStep = payload.resource;
      const steps = state.resource.steps.map(
        step => (step.id === fetchedStep.id ? fetchedStep : step)
      );

      return {
        ...state,
        resource: {
          ...state.resource,
          steps
        },
        isLoading: false
      };
    },

    [`${FETCH_STEP}_ERROR`]: state => {
      return {
        ...state,
        isLoading: false
      };
    },

    [combineActions(
      `${GET_MODULE}_ERROR`,
      `${GET_LECTURE_CONDITION}_ERROR`
    )]: state => {
      return {
        ...state,
        isLoading: false
      };
    }
  },
  initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/module.js